import React from "react";
import HilightTable from "../../../../components/HilightTable";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import NetworkResetDeviceActionButtons from "./NetworkResetDeviceActionButtons";
import DeviceInfoColumn from "../../../../components/DeviceInfoColumn";
import SimpleConnectionStatus from "../../../../components/SimpleConnectionStatus";

const NetworkResetDeviceTable = ({list, t}) => {

    const columns = [
        {
            Header: 'id',
            accessor: 'id',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            headerClassName: " text-center text-wrap",
        },
        {
            Header: 'resetator_label',
            accessor: "resetator.label",
            headerClassName: " text-center text-wrap",
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <DeviceInfoColumn networkDevice={data.resetator}/>
                )
            }
        },
        {
            Header: 'status_resetator',
            accessor: 'resetator.isOnlineNetwork',
            headerClassName: " text-center text-wrap",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <SimpleConnectionStatus status={data.resetator.isOnlineNetwork} hideDescription={true} />
                );
            }
        },
        {
            Header: 'assign_device_label',
            accessor: "networkDevice.label",
            headerClassName: " text-center text-wrap",
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <DeviceInfoColumn networkDevice={data.networkDevice}/>
                )
            }
        },
        {
            Header: 'reset-count',
            accessor: 'resetCount'
        },
        {
            Header: 'reset-interval-seconds',
            accessor: 'resetIntervalSeconds',
            headerClassName: " text-center text-wrap",
        },
        {
            Header: 'last-reset-timestamp',
            accessor: 'turnOnRequestTime',
            headerClassName: " text-center text-wrap",
        },
        {
            Header: 'actions',
            accessor: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right wrapok',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <NetworkResetDeviceActionButtons size={'sm'} row={data}/>
                )
            }
        }
    ]

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { list?.length ? (
                <div className="d-none d-lg-block">
                    <HilightTable
                        columns={columns}
                        data={list}
                    />
                </div>
            ) : (
                <div className="text-center p-4">
                    <h3> { t('network-reset-device-no-content') } </h3>
                </div>
            ) }
        </div>
    )
}
const mapStateToProps = state => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(NetworkResetDeviceTable))
